import { NiceModalContext } from "@ebay/nice-modal-react";
import { useContext } from "react";

export const useActiveDrawerId = () => {
  const modalsMap = useContext(NiceModalContext);

  const activeModal = Object.values(modalsMap).find((modal) => modal.visible || modal.delayVisible);
  const id = activeModal?.args?.id;

  return typeof id === "string" ? id : undefined;
};
